import { render, staticRenderFns } from "./payment-fail.vue?vue&type=template&id=3cdf934b&"
import script from "./payment-fail.vue?vue&type=script&lang=js&"
export * from "./payment-fail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports